<template>
    <div
        v-if="bannerData"
        class="banner-popular"
    >
        <div
            class="banner-popular__bg mb-16"
            :style="{backgroundImage: `url(${bannerData.imageSrc})`}"
        />
        <h4
            class="banner-popular__title fz-18 mb-16 text-semibold"
            v-html="bannerData.title"
        />
        <n-link
            v-if="bannerData.link"
            :to="bannerData.link"
            class="banner-popular__link"
        >
            Подробнее
            <ChevronSvg />
        </n-link>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import ChevronSvg from '@/assets/images/icons/arrows/chevron-down-bold.svg?inline';

export default defineComponent({
    name: 'TneMainMenuBanner',
    components: {
        ChevronSvg,
    },
    props: {
        bannerData: {
            type: Object,
            required: true,
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/banner-popular';
</style>
